export const API_HOST = process.env.REACT_APP_API_HOST;
export const SSO_URL = process.env.REACT_APP_SSO_URL;
export const FO_HOST = process.env.REACT_APP_UI_HOST;
export const FetchStatus = {
  Request: "Request",
  Success: "Success",
  Fail: "Fail",
  Delete: "Delete",
};

export const FetchType = {
  Update: "Update", // 현재 사용하지는 않음
  Delete: "Delete"
}

export const AuthStatus = {
  Login: "Login",
  NotLogin: "NotLogin",
}; 

export const NOT_FIND = "NOTFIND";

export const AUTO_SAVE_TIME = 300000;

// 페이지 URL
export const HOME = "/about";
export const BLOG = "/";
export const BOOKLOG = "booksense";
export const BOOKSENSE_URL = process.env.REACT_APP_BOOKSENSE_URL;